<template>
	<div>
		<div class="flex tab-header">
			<div class="flex align-center title-tabs" v-if="titleTabs">
				{{ titleTabs }}
			</div>
			<div class="content-tabs">
				<div
					v-for="tab in listTab"
					:key="tab.tabKey"
					@click="tabActive(tab)"
					class="ms-tab"
					:class="{ tabActived: tab == tabActived }"
				>
					<div class="ms-border-tab align-center flex">
						<span class="whitespace-no-wrap">{{ tab.title }}</span>
					</div>
				</div>
			</div>
			<div class="timer-content" :class="isTaxaxion ? 'm-r-38' : ''">
				<ms-timer :listTime="syncDataTaxaxionHours" v-if="isShowTimer" />
			</div>
			<div class="report-history-invoice m-l-6" v-if="isTaxaxion">
				<div class="padding-icon m-r-6">
					<div
						class="mi mi-24 mi-sync-now-widget"
						:class="{ 'report-history-inv': true }"
						@click="$emit('reloadData')"
						v-tooltip="{
							content: $t('i18nSystem.ReloadData'),
							placement: 'bottom-end',
						}"
					></div>
				</div>
				<div class="padding-icon">
					<div
						class="mi mi-24 mi-new mi-icon-report"
						:class="{ 'report-history-inv': true }"
						@click="$emit('showFilterPeriod')"
						v-tooltip="{
							content: $t('i18nSystem.ReportHistoryAutoLoad'),
							placement: 'bottom-end',
						}"
					></div>
				</div>
			</div>
		</div>
		<template v-for="tab in listTabRender">
			<components
				ref="component"
				:is="tab.component"
				:key="tab.tabKey"
				v-show="tab == tabActived && !isRouter"
				:initData="tab.initData"
				:data="tab.data"
				v-bind="tab.props"
				:dataItem.sync="tab.dataItem"
			></components>
		</template>
		<router-view v-if="isRouter"></router-view>
	</div>
</template>
<script>
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';

export default {
	name: 'msTab',
	components: {
	},
	props: {
		listTab: {
			default: () => [],
			type: Array,
		},
		titleTabs: {
			default: null,
			type: String,
		},
		isTaxaxion: {
			default: false,
			type: Boolean,
		},
		isRouter: {
			default: false,
			type: Boolean,
		},
		/**
		 * Có hiển thị bộ đếm thời gian tự động đồng bộ
		 */
		isShowTimer: {
			default: false,
			type: Boolean,
		},
	},
	created() {
		const me = this;
		me.tabActive(me.listTab[0]);
	},
	data() {
		return {
			tabActived: null,
			listTabRender: [],
		};
	},
	computed: {
		/**
		 * Lấy ra danh sách thời gian đồng bộ
		 */
		syncDataTaxaxionHours() {
			return window.__env.connectSetting.SyncDataTaxaxionHours;
		},
	},
	methods: {
		//Sự kiện ấn vào chọn tab
		tabActive(tab) {
			const me = this;
			me.tabActived = tab;
			if (me.isRouter) {
				me.$router.push(tab.path);
			} else if (!me.listTabRender.includes(tab)) {
				me.listTabRender.push(tab);
			}
			me.$emit('tabActive', tab);
			EventBusGlobal.$emit(GlobalEventName.ActiveTab, tab);
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msTab.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msTab.scss';
}
.padding-icon {
	border-radius: 6px;
	border: 1px solid rgb(180, 180, 180);
	padding: 4px;
}
.timer-content {
	position: absolute;
	right: 35px;
}
</style>
